import { render, staticRenderFns } from "./settings-color.vue?vue&type=template&id=1769397f&"
import script from "./settings-color.vue?vue&type=script&lang=js&"
export * from "./settings-color.vue?vue&type=script&lang=js&"
import style0 from "./settings-color.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports